import {selector} from './selector';
import * as events from "./events";

const PageRegisterTagFormTasHR = (function ($) {

    function checkTerms() {
        $(selector.btnSubmit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function initEvents() {
        $(document).on('click', selector.btnSubmit, events.formSubmit);
        $(document).on('click', selector.languageSwithch, events.changeLanguage);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);

        $(document).on('submit', selector.form.main, function (e) {
            const $submitBtn = $(selector.btn.submit);
            $submitBtn.prop('disabled', true);
            $submitBtn.addClass('disabled');
        });

    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTagFormTasHR};